import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import * as Yup from 'yup';
import * as bie from "react-bootstrap";
import { ImagePdfBucket } from '../../CommonUtils/ImagesBase64';
import { viewImage } from '../../CommonUtils/viewImage';
import { FaEye } from 'react-icons/fa';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import CommonFormHeading from '../../CommonUtils/CommonFormHeading';
import Affidavit_Sample_Pdf from "../NonOamdc/Affidavit_Sample_Pdf.docx";
import { FaHandPointRight } from "react-icons/fa";
import { FaRegFilePdf } from "react-icons/fa";


export default function AfflUploadAffidavit() {
    const hasFetchedData = useRef(false)
    const formik = useFormik({
        initialValues: {
            affidavit: '',
            info: '',
        },
        validationSchema: Yup.object().shape({
            affidavit: Yup.string().required(ERROR_MSG).nullable(),
            info: Yup.boolean()
                .oneOf([true], "You must accept the terms and conditions")
                .required("You must accept the terms and conditions").nullable()
        }),
        onSubmit: async (values) => {
            const statusUrl = `${config.url.API_URL}getclgSectionStatus/affidavit`;
            try {
                const res = await CommonAxiosGet(statusUrl);
                const val = res?.data?.incompleteSections;
                if (val && val.length) {
                    // const formattedList = val.join('\n');
                    const formattedList = val
                        .map(item => item
                            .replace(/_/g, ' ')
                            .replace(/\b\w/g, char => char.toUpperCase())
                        )
                        .join('\n');

                    Swal.fire({
                        title: 'Incomplete Sections',
                        // html: `<pre style="text-align: left;">${formattedList}</pre>`,
                        html: `<pre style="text-align: left; font-family: 'Courier New', monospace; color: #ff6347;">${formattedList}</pre>`,
                        icon: 'warning',
                        confirmButtonText: 'OK',
                        backdrop: false,
                    });
                    return;
                }
                else {
                    const submitUrl = `${config.url.API_URL}saveAffidavit`;
                    const submitResponse = await CommonAxiosPost(submitUrl, values);
                    if (submitResponse?.data?.scode === '01') {
                        successAlert2("Successfully Submitted");
                        GetAffidavit();
                    } else {
                        failureAlert('Failed to Submit');
                    }
                }
            } catch (error) {
                console.error("Error during form submission:", error);
                Swal.fire('Error', 'An unexpected error occurred. Please try again later.', 'error');
            }
        }
    });
    const [affidavitpdf, setaffidavitpdf] = useState('');
    function GetAffidavit() {
        let url = config.url.API_URL + `getAffidavit`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setaffidavitpdf(res?.data?.getAffidavit[0]?.affidavit_pdf);
                formik.setFieldValue("info", res?.data?.getAffidavit[0]?.is_furnished_info)
                formik.setFieldValue("affidavit", res?.data?.getAffidavit[0]?.affidavit_pdf)
            } else {
                setaffidavitpdf([])
            }
        })
    }
    useEffect(() => {
        if (!hasFetchedData.current) {
            GetAffidavit()
            hasFetchedData.current = true
        }
    }, [])
    return (
        <>
            <bie.Container fluid className="px-1" >
                <CommonFormHeading heading={"Affidavit Upload"} />

                <FormikProvider value={formik}>
                    <Form onChange={formik.handleChange} onSubmit={formik.handleSubmit} className="affl-form" >
                        <bie.Container className="outer-page-content-container shadow-none px-4 m-0 mw-100 pb-3">
                            <bie.Row className="px-4 pt-3 mb-4 align-items-center">
                                <bie.Col xs={12} className="d-flex justify-content-end">
                                    <a
                                        href={Affidavit_Sample_Pdf}
                                        download
                                        style={{
                                            color: "#a83264",
                                            fontSize: "18px",
                                            fontFamily: "sans-serif"
                                        }}
                                    >
                                        <FaHandPointRight size={20} /> Click here to download Affidavit Sample Pdf <FaRegFilePdf size={20} />
                                    </a>
                                </bie.Col>


                                <div className="inner-herbpage-service-title-sub">
                                    <h1 className='mb-0'>Affidavit Upload</h1>
                                </div>

                                <bie.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="mb-2">
                                    <bie.Alert variant='danger' className='affl-alert mt-3'>
                                        <p style={{ fontSize: "14px" }}> <Field type="checkbox" name="info" checked={formik?.values?.info} onChange={formik.handleChange} />
                                            <ErrorMessage name="info" component="div" className="text-error" />
                                            &emsp;
                                            I agree the above submitted information,documents,Geo positions are true,
                                            I hereby understand and agree that the application being submitted for Affiliation will be processed by the University only. Role of APCFSS is limited only to facilitate the Submission of Application through this portal to the university
                                            Please note that the APCFSS (Andhra Pradesh Centre for Financial Systems and Services) is not responsible for legal and RTI cases on any aspect with regard
                                            to affiliation process since the APCFSS is only providing technical support to the parties for online affiliation process. </p>
                                    </bie.Alert>
                                </bie.Col>
                                <bie.Col lg={3} className="mb-4">
                                    <label><b className="field-mandatory"> Affidavit Upload:</b></label>
                                    <div className='d-flex align-items-center'>
                                        <input type="file" accept="application/pdf" name="affidavit" className="form-control mt-2" style={{ width: 'auto' }}
                                            onChange={(e) => {
                                                let filename = `affidavit`;
                                                let path = "/Uploads/AffiliationPDFs/2023/"
                                                ImagePdfBucket(e, formik, path, "affidavit", filename, "pdf")
                                            }} />
                                        <ErrorMessage name="affidavit" component="div" className="btn btn-primary" />
                                        {affidavitpdf && <button type='button' className='ms-2 btn btn-primary' onClick={() => { viewImage(affidavitpdf) }}><FaEye size={25} /> </button>}
                                    </div>
                                </bie.Col>

                                <div className=''>
                                    <button type='submit' className='btn btn-success btn-sm float-end' >Submit</button>
                                </div>
                            </bie.Row></bie.Container></Form></FormikProvider>
            </bie.Container>
        </>
    )
}
